<template>
  <main class="legal-content">
    <slot />
  </main>
</template>

<style scoped lang="scss">
.legal-content{
  width: min(100%, 900px);
  min-height: 28vh;
  margin: 0 auto;
  padding: clamp(2.5rem, 6vw, 5rem) 1.5rem;
  color: rgb(214 211 209);
  text-align: left;

  :deep(h2),
  :deep(h3){
    margin: 2.25rem 0 0.75rem;
    color: white;
    font-weight: 700;
    line-height: 1.2;
  }

  :deep(h2){
    font-size: clamp(1.35rem, 3vw, 1.75rem);
  }

  :deep(h3){
    font-size: 1.15rem;
  }

  :deep(p){
    margin: 0 0 1.15rem;
    font-size: 1rem;
    line-height: 1.72;
  }

  :deep(a){
    color: #7db9df;
    text-underline-offset: 3px;
  }

  :deep(> :first-child){
    margin-top: 0;
  }
}
</style>
